/**
 * Read a Vite env var as boolean with robust parsing.
 * Accepts: true/false, 1/0, yes/no, on/off (case-insensitive).
 * Falls back to defaultValue if not set or unparsable.
 */
import { parseBoolean } from './value-parser'

export function getEnvAsBoolean(key: string, defaultValue = false): boolean {
  const raw = import.meta.env?.[key]
  return parseBoolean(raw, defaultValue)
}
